export default function SlopeSliderSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Slope is a feeling before it's a formula
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most students learn slope as m = (y₂ − y₁) / (x₂ − x₁), then never
        develop the visceral sense that a slope of 3 is *steep* and a slope
        of 0.3 is *gentle*. The formula is correct and you'll need it, but
        if you don't have the intuition first, the algebra doesn't tell you
        when you've made an error. Slope Slider builds the intuition first.
        You drag the line. You see the rise. You see the run. You internalize
        the relationship before the symbols arrive.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why rise-over-run is the right mental model
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Slope can be described many ways — derivative, rate of change,
        gradient — but the original meaning is mechanical: for every step
        right (the run), how far up or down does the line go (the rise)?
        That's the model a roofer or a road engineer uses. When the slope
        is 1, walking one unit right means walking one unit up. When the
        slope is 0, the line is flat. When the slope is negative, walking
        right means walking down. Once that picture is built, the formula
        is just a tool for measuring what you already see.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The game's progression
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Early rounds give whole-number slopes (1, 2, −1, 3) so the visual
        and the number align cleanly. Later rounds introduce fractions
        (1/2, 2/3, −3/4) which require you to feel where the line lands
        between integer steps. The hardest rounds give slopes like 5/7
        where the line crosses gridlines at non-obvious points and you
        have to trust the rise-over-run mechanic rather than counting.
        Every round is graded by how close your dragged slope is to the
        target slope.
      </p>
    </>
  );
}
